import { toast } from "react-toastify";
import { errMsg } from "../../utils/helperFunction";
import {
  getSectorsCategoriesApi,
  getSectorByIdApi,
  getSectorWiseByIdApi,
  getSectorObservationsApi,
  getAllSectorsApi, getPopularSectorsApi, getFindSupplierApi, getCategoryExpenditureAnalysisApi, getStatesApi, getImportDataApi
  , getexportDataApi,getSectorCategoriesApi
} from "../../api/sectorApi";
import { getMetricCatalogApi, getMetricLevelInsightsApi, getExpertImpactsApi,createExpertImpactApi } from "../../api/expertSectorApi";
export const getSectorsCategories = () => async (dispatch) => {
  try {
    dispatch({
      type: "SECTOR_REQ",
    });

    const response = await getSectorsCategoriesApi();

    dispatch({
      type: "SECTOR_FETCH_SUC",
      payload: response,
    });
  } catch (err) {
    const message = errMsg(err);
    dispatch({
      type: "SECTOR_ERROR",
    });
    toast.error(message, {
      toastId: message,
      position: "bottom-center",
    });
  }
};

export const getSectorById = (sectorId) => async (dispatch) => {
  try {
    dispatch({
      type: "SECTOR_REQ",
    });

    const response = await getSectorByIdApi(sectorId);

    dispatch({
      type: "SECTOR_DETAIL_FETCH_SUC",
      payload: response,
    });
  } catch (err) {
    const message = errMsg(err);
    dispatch({
      type: "SECTOR_ERROR",
    });
    toast.error(message, {
      toastId: message,
      position: "bottom-center",
    });
  }
};


export const getSectorWiseById = (sectorId) => async (dispatch) => {
  try {
    dispatch({
      type: "SECTOR_WISE_REQ",
    });

    const response = await getSectorWiseByIdApi(sectorId);
    console.log("sectorId sent:", sectorId);
    console.log("Response received:", response);

    dispatch({
      type: "SECTOR_WISE_FETCH_SUC",
      payload: response,
    });
  } catch (err) {
    const message = errMsg(err);
    dispatch({
      type: "SECTOR_WISE_ERROR",
    });
    toast.error(message, {
      toastId: message,
      position: "bottom-center",
    });
  }
};

export const getSectorObservations = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: "SECTOR_OBSERVATION_REQ",
    });

    const response = await getSectorObservationsApi({ ...payload });

    dispatch({
      type: "SECTOR_OBSERVATION_FETCH_SUC",
      payload: response,
    });
  } catch (err) {
    // const message = errMsg(err);
    dispatch({
      type: "SECTOR_OBSERVATION_ERROR",
    });
    // toast.error(message, {
    //   toastId: message,
    //   position: "bottom-center",
    // });
  }
};

// export const getAllSectors = () => async (dispatch) => {
//   try {
//     dispatch({
//       type: "SECTORS_REQ",
//     });

//     const response = await getAllSectorsApi();

//     dispatch({
//       type: "SECTORS_FETCH_SUC",
//       payload: response,
//     });
//   } catch (err) {
//     const message = errMsg(err);
//     dispatch({
//       type: "SECTORS_ERROR",
//     });
//     toast.error(message, {
//       toastId: message,
//       position: "bottom-center",
//     });
//   }
// };

export const getPopularSectors = () => async (dispatch) => {
  try {
    dispatch({
      type: "SECTOR_POPULAR_REQ",
    });

    const response = await getPopularSectorsApi();

    dispatch({
      type: "SECTOR_POPULAR_FETCH_SUC",
      payload: response,
    });
  } catch (err) {
    const message = errMsg(err);
    dispatch({
      type: "SECTOR_POPULAR_ERROR",
    });
    toast.error(message, {
      toastId: message,
      position: "bottom-center",
    });
  }
};







export const getFindSuppliers = (sectorId) => async (dispatch) => {
  try {
    dispatch({ type: "SECTOR_FIND_SUPPLIERS_REQUEST" });

    const response = await getFindSupplierApi(sectorId);
    console.log("API response find supplier:", response);

    if (response.status) {

      const mappedData = response.data.map((supplier) => {
        let location = supplier.companyRegdOffice;
        if (location) {
          const parts = location.split(".");
          location = parts[parts.length - 1].trim();
        }
        return {
          ...supplier,
          location,
        };
      });

      dispatch({
        type: "SECTOR_FIND_SUPPLIERS_SUCCESS",
        payload: {
          status: "success",
          message: response.message,
          data: mappedData,
        },
      });
    }
  } catch (error) {
    console.error("API error :", error);
    dispatch({
      type: "SECTOR_FIND_SUPPLIERS_FAILURE",
      payload: error.message,
    });
  }
};



export const getMarketSizeAnalysis = (payload) => async (dispatch) => {
  try {
    dispatch({ type: "GET_MARKET_SIZE_REQUEST" });

    const response = await getCategoryExpenditureAnalysisApi(payload);
    // console.log("API Response:", response.data);

    if (response?.success) {
      dispatch({
        type: "GET_MARKET_SIZE_SUCCESS",
        payload: {
          success: true,
          message: response.message,
          data: response.data,
        },
      });
    } else {
      dispatch({
        type: "GET_MARKET_SIZE_FAILURE",
        payload: response.message || "Something went wrong",
      });
    }
  } catch (error) {
    dispatch({
      type: "GET_MARKET_SIZE_FAILURE",
      payload: error.message || "Request failed",
    });
  }
};




export const getStates = () => async (dispatch) => {
  try {
    dispatch({ type: "GET_STATES_REQUEST" });

    const response = await getStatesApi();

    if (response && typeof response === "object") {
      dispatch({
        type: "GET_STATES_SUCCESS",
        payload: {
          status: "success",
          message: "States fetched successfully",
          data: response,
        },
      });
    } else {
      dispatch({
        type: "GET_STATES_FAILURE",
        payload: "Invalid response format or empty result",
      });
    }
  } catch (error) {
    dispatch({
      type: "GET_STATES_FAILURE",
      payload: error.message || "Failed to fetch states",
    });
  }
};


export const fetchImportData = () => async (dispatch) => {
  dispatch({ type: "FETCH_IMPORT_DATA_REQUEST" });

  try {
    const response = await getImportDataApi();
    // console.log(" API response from getImportDataApi ", response);

    if (!response?.status) {
      throw new Error(response?.message || "Invalid response format");
    }

    dispatch({
      type: "FETCH_IMPORT_DATA_SUCCESS",
      payload: response.data,
    });
  } catch (error) {
    console.error("DEBUG: API fetch failed →", error);

    dispatch({
      type: "FETCH_IMPORT_DATA_FAILURE",
      payload: error.message || "Something went wrong",
    });
  }
};



export const fetchExportData = () => async (dispatch) => {
  dispatch({ type: "FETCH_EXPORT_DATA_REQUEST" });

  try {
    const apiResponse = await getexportDataApi();

    console.debug("Raw API response:", apiResponse);

    if (!apiResponse || typeof apiResponse !== "object") {
      throw new Error("Invalid response from API");
    }

    const exportData = apiResponse.data || apiResponse;

    if (!exportData || Object.keys(exportData).length === 0) {
      throw new Error("No export data available");
    }

    console.debug("Export data:", exportData);

    dispatch({
      type: "FETCH_EXPORT_DATA_SUCCESS",
      payload: exportData,
    });
  } catch (error) {
    console.error("DEBUG: Export API fetch failed →", error);
    dispatch({
      type: "FETCH_EXPORT_DATA_FAILURE",
      payload: { message: error.message || "Failed to fetch export data" },
    });
  }
};


export const getSectorCategories = () => async (dispatch) => {
  try {
    dispatch({ type: "CATEGORIES_REQ" });

    const response = await getSectorCategoriesApi();
    
    console.log("getSectorCategories raw response:", response);

    dispatch({
      type: "CATEGORIES_FETCH_SUC",
      payload: response,
    });
  } catch (err) {
    const message = errMsg(err);
    dispatch({ type: "CATEGORIES_ERROR" });
    toast.error(message, {
      toastId: message,
      position: "bottom-center",
    });
  }
};
// export const getSectorCategories = () => async (dispatch) => {
//   try {
//     dispatch({ type: "CATEGORIES_REQ" });

//     // TEMP: Stop API call, return mock data
//     const response = []; // or some sample JSON

//     console.log("getSectorCategories: API disabled, using mock data");

//     dispatch({
//       type: "CATEGORIES_FETCH_SUC",
//       payload: response,
//     });
//   } catch (err) {
//     dispatch({ type: "CATEGORIES_ERROR" });
//   }
// };


export const getAllSectors = (categoryName) => async (dispatch) => {
  try {
    dispatch({ type: "SECTORS_REQ" });
    console.log("Fetching sectors for category:", categoryName);

    const response = await getAllSectorsApi(categoryName);
    console.log("ProductResponse from API:", response); 
    dispatch({
      type: "SECTORS_FETCH_SUC",
      payload: {
        status: true,
        message: `Sectors fetched successfully for category '${categoryName}'`,
        data: response, 
      },
    });
  } catch (err) {
    dispatch({ type: "SECTORS_ERROR" });
  }
};


export const getExpertMetricCatalog = () => async (dispatch) => {
  try {
    dispatch({ type: "METRIC_REQ" });

    const response = await getMetricCatalogApi();

    dispatch({
      type: "METRIC_FETCH_SUC",
      payload: response,
    });
  } catch (err) {
    const message = errMsg(err);
    dispatch({ type: "METRIC_ERROR" });
    toast.error(message, {
      toastId: message,
      position: "bottom-center",
    });
  }
};





export const getMetricLevelInsights = ({ companyId, year }) => async (dispatch) => {
  try {
    console.debug("[ACTION] getMetricLevelInsights dispatch", { companyId, year });
    dispatch({ type: "METRIC_LEVEL_INSIGHTS_REQ" });

    const response = await getMetricLevelInsightsApi({ companyId, year });
    console.debug("[ACTION] getMetricLevelInsights success:", response);

    dispatch({
      type: "METRIC_LEVEL_INSIGHTS_SUC",
      payload: response?.data || response, // store response.data if your API wrapper nests it
    });
  } catch (err) {
    const message = errMsg(err);
    console.debug("[ACTION] getMetricLevelInsights error:", err);
    dispatch({ type: "METRIC_LEVEL_INSIGHTS_ERR" });
    toast.error(message, {
      toastId: message,
      position: "bottom-center",
    });
  }
};

export const getExpertImpacts = (expertId) => async (dispatch) => {
  try {
    dispatch({ type: "EXPERT_IMPACTS_REQ", meta: { expertId } });

    const res = await getExpertImpactsApi(expertId); // GET /api/v1/experts/:id/impacts

    dispatch({
      type: "EXPERT_IMPACTS_FETCH_SUC",
      payload: res,                  // { status, message, data: { items: [...] } }
      meta: { expertId },            // <-- critical
    });
  } catch (err) {
    dispatch({ type: "EXPERT_IMPACTS_ERR", meta: { expertId } });
  }
};



export const createExpertImpact = (expertId, payload) => async (dispatch) => {
  try {
    dispatch({ type: "EXPERT_IMPACT_CREATE_REQ", meta: { expertId } });

    const response = await createExpertImpactApi(expertId, payload);

    dispatch({
      type: "EXPERT_IMPACT_CREATE_SUC",
      payload: response,           // shape: { status, message, data: { ...impact } }
      meta: { expertId },
    });

    toast.success("Impact created", { position: "bottom-center" });
  } catch (err) {
    const message = errMsg(err);
    dispatch({ type: "EXPERT_IMPACT_CREATE_ERR", meta: { expertId } });
    toast.error(message, { position: "bottom-center", toastId: message });
  }
};